module.exports = __webpack_public_path__ + "img/ic_140_achievement_spitzenreiter.85b9320d.svg";